import { businessStore } from 'entities/business/model/business-card.store';
import { userStore } from 'entities/user/model/user.store';
import { makeAutoObservable } from 'mobx';
import { SSOApi } from 'shared/api';
import { LoadingStatusEnum } from 'shared/types';

class AccessTokenStore {
  isAuth = false;
  isLoadingTokenStatus = LoadingStatusEnum.NOT_LOADING;
  private accessToken?: string;
  private _tokenReadyPromise: Promise<void> | null = null;
  private _resolveTokenReady: (() => void) | null = null;

  constructor() {
    makeAutoObservable(this);
    this.refreshToken();
  }
  getAccessToken() {
    return this.accessToken;
  }
  waitForToken(): Promise<void> {
    if (this.isLoadingTokenStatus !== LoadingStatusEnum.LOADING) {
      return Promise.resolve();
    }
    if (!this._tokenReadyPromise) {
      this._tokenReadyPromise = new Promise((resolve) => {
        this._resolveTokenReady = resolve;
      });
    }
    return this._tokenReadyPromise;
  }
  setToken(newToken: string) {
    if (newToken) {
      this.accessToken = newToken;
      this.isAuth = true;
      this.isLoadingTokenStatus = LoadingStatusEnum.SUCCESS;
    } else {
      this.isAuth = false;
      this.isLoadingTokenStatus = LoadingStatusEnum.ERROR;
    }
    this._resolveTokenReady?.();
    this._resolveTokenReady = null;
    this._tokenReadyPromise = null;
  }
  private static clearLocalStorage() {
    ['businessId', 'pointId', 'selectedDate', 'microSlotDuration'].forEach(
      (key) => localStorage.removeItem(key)
    );
  }
  clear() {
    AccessTokenStore.clearLocalStorage();
    businessStore.clearAllData();
    userStore.clear();
    this.accessToken = '';
    this.isAuth = false;
    this.isLoadingTokenStatus = LoadingStatusEnum.NOT_LOADING;
    this._resolveTokenReady?.();
    this._resolveTokenReady = null;
    this._tokenReadyPromise = null;
  }
  refreshToken = async () => {
    this.isLoadingTokenStatus = LoadingStatusEnum.LOADING;

    try {
      const token = await SSOApi.refreshSession();
      this.setToken(token);
    } catch (error) {
      this.clear();
      this.isLoadingTokenStatus = LoadingStatusEnum.ERROR;
      this._resolveTokenReady?.();
      this._resolveTokenReady = null;
      this._tokenReadyPromise = null;
      if (error instanceof Error) {
        console.log('Token refresh failed:', error.message);
      }
    }
  };
}

export const accessTokenStore = new AccessTokenStore();
